<template>
  <el-dialog
    :visible.sync="visible"
    width="80vw"
    top="5vh"
    :close-on-click-modal="true"
    :before-close="handleClose"
    append-to-body
    class="party-member-info-dialog"
  >
    <div class="info-section">
      <div class="section-title">申报信息</div>
      <el-row :gutter="24" class="info-item-row">
        <el-col :span="12"><div class="info-item"><span>姓名</span>{{ detail.name || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>性别</span>{{ genderText(detail.gender) }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>年龄</span>{{ detail.age || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>文化程度</span>{{ detail.education || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>入党时间</span>{{ detail.joinPartyTime }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>身份证号码</span>{{ detail.idCard || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>联系方式</span>{{ detail.phone || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>居住地址</span>{{ detail.address || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>现党员组织关系的党支部名称</span>{{ detail.partyBranch || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>商户所属社区及市场主体</span>{{ detail.communityAndMarket || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>商户名称及地址</span>{{ detail.shopNameAndAddress || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>商户职务</span>{{ detail.position || '-' }}</div></el-col>
        <el-col :span="12"><div class="info-item"><span>基本情况（经营范围和情况）</span>{{ detail.basicInformation || '-' }}</div></el-col>
        <el-col :span="24"><div class="info-item"><span>所获荣誉</span>{{ detail.honor || '-' }}</div></el-col>
        <el-col :span="12">
          <div class="info-item">
            <span>本人照片：</span>
            <template v-if="detail.images && detail.images.length && detail.images[0].url">
              <el-image
                v-for="(img, idx) in detail.images"
                :key="idx"
                :src="img.url"
                style="width: 80px; height: 80px; border-radius: 6px; margin-right: 10px;"
                :preview-src-list="detail.images.map(i => i.url)"
              />
            </template>
            <span v-else>无</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-item">
            <span>营业执照照片：</span>
            <template v-if="detail.businessLicense">
              <el-image
                :src="detail.businessLicense"
                style="width: 80px; height: 80px; border-radius: 6px; margin-right: 10px;"
                :preview-src-list="[detail.businessLicense]"
              />
            </template>
            <span v-else>无</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="result-section">
      <div class="section-title">评选结果</div>
      <el-row class="result-item-row" :gutter="24">
        <el-col :span="24"><div class="info-item"><span>评选结果：</span>{{ processStatusText(detail.processStatus) }}</div></el-col>
        <el-col :span="24"><div class="info-item"><span>备注：</span>{{ detail.remark || '-' }}</div></el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PartyMember from '@/axios/api/partyMember.js'
export default {
  name: 'PartyMemberInfoDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    declareId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      detail: {},
      loading: false
    }
  },
  watch: {
    visible(val) {
      if (val && this.declareId) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleClose() {
      this.$emit('close')
    },
    async fetchDetail() {
      this.loading = true
      try {
        let res = await PartyMember.getDeclareApplication(this.declareId)
        if (res && res.data) {
          this.detail = res.data
        } else {
          this.detail = {}
        }
      } catch (e) {
        this.detail = {}
      }
      this.loading = false
    },
    genderText(val) {
      if (val === 1) return '男'
      if (val === 2) return '女'
      return '-'
    },
    processStatusText(val) {
      if (val === 2) return '通过'
      if (val === 0) return '未通过'
      if (val === 1) return '未评选'
      return '-'
    },
    formatDate(ts) {
      if (!ts) return '-'
      const d = new Date(ts)
      const y = d.getFullYear()
      const m = (d.getMonth() + 1).toString().padStart(2, '0')
      const day = d.getDate().toString().padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  }
}
</script>

<style scoped>
.party-member-info-dialog >>> .el-dialog__body {
  background: #F5F5F5;
  padding: 0 30px 30px 30px;
}
.party-member-info-dialog >>> .el-dialog__header {
  background: #F5F5F5;
}
.party-member-info-dialog >>> .el-dialog__footer {
  background: #F5F5F5;
}
.info-section {
  margin-bottom: 34px;
}
.section-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 18px;
  color: #333;
}
.info-item {
  margin-bottom: 28px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
}
.info-item span:first-child {
  color: #666666;
  width: 98px;
  margin-right: 26px;
  display: inline-block;
}
.dialog-footer {
  text-align: center;
  display: flex;
  justify-content: center;
}
.info-item-row {
  background: #FFFFFF;
  padding: 24px 12px 6px 12px;
  box-sizing: border-box;
}
.result-item-row {
  background: #FFFFFF;
  padding: 18px 12px 0 12px;
}
</style>
